import React, { useEffect, useState, useCallback } from "react";
import { translate } from "../../utils/translations/translate";
import Button from "../UI/Button";
import { FilePicker } from "../UI/FilePicker";
import { FileInfo } from "../UI/FileInfo";
import { BILLABLE_OPTIONS, PAY_CODE_OPTIONS } from "../../utils/constants";
import { Button as TextButton } from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { Dropdown } from "../UI/Dropdown";
import moment from "moment";
import { useTimeSheetManager } from "./hooks/useTimeSheetManager";
import Alert from "@mui/material/Alert";
import EditOffSharpIcon from "@mui/icons-material/EditOffSharp";
import { NumericTimeEntry } from "../UI/NumericTimeEntry";
import TextField from "@mui/material/TextField";
import { Label } from "../UI/styles";

import { StyledCardSection } from "../Projects/styles";
const TimesheetDetails = ({
  selectedWeek,
  weekDaysArr,
  syncTimesheetDetails,
  projectId,
  projectName,
  managerName,
  managerEmail,
  taskList,
  onModeChange,
  showEditExit,
  showCopyButton,
  projectSavedData,
  onCopyPreviousTimesheet,
  isReadOnlyMode,
  setToastInfo,
  onDeleteAttachment,
  savedAttachments,
}) => {
  const isViewMode = false;
  const {
    comments: savedComments,
    timesheetId,
    timesheetData,
  } = projectSavedData;
  const {
    alertMessage,
    taskRows,
    addNewTaskRow,
    deleteTaskRow,
    formattedWeekLabels,
    getProjectTaskRowValues,
    hrMappingByDate,
    rowMappingHours,
    totalInputtedHours,
    updateProjectTaskEntries,
    updateTimeEntries,
    commentBoxRef,
    reInitializeTaskRows,
    copyWithEntries,
    handleAddAttachment,
    handleFileChange,
    handleOtherAttachmentsRemove,
    handleMaxLimitExceeded,
    attachments,
    setAttachments,
  } = useTimeSheetManager(
    weekDaysArr,
    timesheetId,
    setToastInfo,
    onDeleteAttachment
  );
  // console.log(savedAttachments, attachments);

  useEffect(() => {
    if (typeof savedAttachments === "string") {
      let savedAttachmentsTemp = savedAttachments ?.split(",").map((item) => ({
        file: {
          fileName: item,
          orignalFile: item,
        },
      }));
      if (!savedAttachmentsTemp ?.length) {
        savedAttachmentsTemp = [{ file: null }];
      }
      setAttachments(savedAttachmentsTemp);
    } else if (Array.isArray(savedAttachments) && savedAttachments.length > 0) {
      let savedAttachmentsTemp = savedAttachments ?.map((item) => ({
        file: item,
      }));
      if (!savedAttachmentsTemp ?.length) {
        savedAttachmentsTemp = [{ file: null }];
      }
      const updateAttachments = savedAttachmentsTemp ?.filter(item => item ?.file && typeof item ?.file === 'object');
      setAttachments(updateAttachments);
    }
  }, []);

  const handleCopyFunction = async () => {
    try {
      const prevWeekEntries = await onCopyPreviousTimesheet(
        projectId,
        selectedWeek
      );
      copyWithEntries(prevWeekEntries);
    } catch (e) {
      copyWithEntries([]);
    }
  };
  useEffect(() => {
    if (Array.isArray(timesheetData) && timesheetData.length) {
      reInitializeTaskRows(timesheetData);
    } else {
      reInitializeTaskRows([]);
    }
  }, [timesheetData, reInitializeTaskRows]);
  useEffect(() => {
    if (savedComments && commentBoxRef.current) {
      commentBoxRef.current.value = savedComments;
    }
  }, [savedComments, commentBoxRef]);
  useEffect(() => {
    const comments = commentBoxRef.current ?.value || "";
    syncTimesheetDetails(projectId, {
      projectId,
      timesheetId,
      comments,
      tasks: taskRows,
      attachments,
    });
  }, [
      syncTimesheetDetails,
      projectId,
      taskRows,
      savedComments,
      commentBoxRef,
      timesheetId,
      handleAddAttachment,
      handleFileChange,
      handleOtherAttachmentsRemove,
      handleMaxLimitExceeded,
      attachments,
    ]);
  return (
    <StyledCardSection>
      <section
        className={`tma_time_entry_container ${
          isViewMode ? "tma_time_entry_container_read" : ""
          }`}
      >
        {alertMessage && (
          <Alert severity="info" sx={{ marginBottom: "1rem" }}>
            {alertMessage}
          </Alert>
        )}
        <section className="tma_proj_details">
          {showEditExit && (
            <button
              className="tima_time_editoff-button"
              onClick={() => {
                onModeChange(projectId, "read");
              }}
            >
              <EditOffSharpIcon titleAccess="Exit timesheet edit mode" />
            </button>
          )}
          <div className="tma_prj_info_container">
            <p className="tma_pnf_label">{translate("labels.dateRange")}</p>
            <p className="tma_pnf_value">
              {moment(selectedWeek.firstDay).format("MM/DD/YYYY")} -{" "}
              {moment(selectedWeek.lastDay).format("MM/DD/YYYY")}
            </p>
          </div>
          <div className="tma_prj_info_container">
            <p className="tma_pnf_label">{translate("labels.projectName")}</p>
            <p className="tma_pnf_value">{projectName}</p>
          </div>
          <div className="tma_prj_info_container">
            <p className="tma_pnf_label">{translate("labels.projectId")}</p>
            <p className="tma_pnf_value">{projectId}</p>
          </div>
          <div className="tma_prj_info_container">
            <p className="tma_pnf_label">{translate("labels.manager")}</p>
            <p className="tma_pnf_value">
              {managerName} - {managerEmail}
            </p>
          </div>
          {showCopyButton && (
            <div className="tma_copy_previous">
              <TextButton
                title={translate("labels.copyTimesheetInfo")}
                onClick={handleCopyFunction}
              >
                {translate("labels.copyPreviousWeekTime")}
              </TextButton>
            </div>
          )}
        </section>
        <section className="tma_time_entry">
          <div className="tma_entry_sheet_info">
            <div className="form_card timsheet-entry">
              <div className="tma_task_headers">
                <div className="task_headers_item_labels">
                  <div className="tma_drpdwn_action_row">
                    <Label>
                      <span>{translate("labels.projectTask")}</span>
                      <span className="tma_label_required">
                        ({translate("labels.required")})
                      </span>
                    </Label>
                  </div>
                  <div className="tma_drpdwn_action_row">
                    <Label>
                      <span>
                        {isViewMode
                          ? translate("labels.billableType")
                          : translate("labels.billableLable")}
                      </span>
                      <span className="tma_label_required">
                        ({translate("labels.required")})
                      </span>
                    </Label>
                  </div>
                  <div className="tma_drpdwn_action_row">
                    <Label>
                      <span>{translate("labels.payCode")}</span>{" "}
                      <span className="tma_label_required">
                        ({translate("labels.required")})
                      </span>
                    </Label>
                  </div>
                </div>
                <div className="empty-row">{translate("labels.emptyRow")}</div>
                <div className="tma_prj_action_items">
                  {taskRows.map((_, rowIndex) => {
                    const { billableType, payCode, projectTask } =
                      getProjectTaskRowValues(rowIndex);
                    return (
                      <div className="tma_drpdwn-row" key={rowIndex}>
                        {!isViewMode && (
                          <div className="tma_delete_row">
                            <DeleteOutlineIcon
                              onClick={() => {
                                deleteTaskRow(rowIndex);
                              }}
                            />
                          </div>
                        )}
                        <div className="tma_drpdwn_action_row withLabels">
                          <Dropdown
                            id={"1"}
                            placeholder="Select"
                            initialValue={projectTask}
                            options={taskList}
                            key={rowIndex + projectTask}
                            disabled={isViewMode}
                            onChange={(option) => {
                              updateProjectTaskEntries(
                                rowIndex,
                                "projectTask",
                                option
                              );
                            }}
                          />
                        </div>
                        <div className="tma_drpdwn_action_row timesheet_labels withLabels">
                          <Dropdown
                            id={"2"}
                            placeholder="Select"
                            options={BILLABLE_OPTIONS}
                            initialValue={billableType}
                            key={rowIndex + billableType}
                            disabled={isViewMode}
                            onChange={(option) => {
                              updateProjectTaskEntries(
                                rowIndex,
                                "billableType",
                                option
                              );
                            }}
                          />
                        </div>
                        <div className="tma_drpdwn_action_row withLabels">
                          <Dropdown
                            id={"3"}
                            placeholder="Select"
                            options={PAY_CODE_OPTIONS}
                            initialValue={payCode}
                            key={rowIndex + payCode}
                            disabled={isViewMode}
                            onChange={(option) => {
                              updateProjectTaskEntries(
                                rowIndex,
                                "payCode",
                                option
                              );
                            }}
                          />
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
              <div className="tma_day_labels--overflow">
                <div className="tma_day_labels">
                  {formattedWeekLabels.map((week, idx) => {
                    return (
                      <div
                        className={`tma_days_info  ${
                          idx === formattedWeekLabels.length - 1
                            ? "tma_header_total_label"
                            : ""
                          }`}
                        key={idx}
                      >
                        <div className={`tma_header_days_labels`}>
                          <p className="day-label">{week.dayLabel}</p>
                          <p className="date-label">{week.dateLabel}</p>
                        </div>
                        <div className="tma_days_entries_action">
                          {taskRows.map((_, hrIndex) => {
                            const isTotalCol =
                              idx === formattedWeekLabels.length - 1;
                            const isFutureDate = week.isFutureDate;
                            const inputVal = isFutureDate
                              ? 0
                              : isTotalCol
                                ? rowMappingHours[hrIndex].rowTotal
                                : hrMappingByDate[week.comparator].rows[hrIndex];
                            return (
                              <NumericTimeEntry
                                value={inputVal}
                                isReadOnlyInput={isTotalCol || isViewMode}
                                disabled={week.isFutureDate || isViewMode}
                                id={`${projectId}-tma_input-entry_${hrIndex}-${idx}`}
                                key={`${projectId}-tma_input-entry_${hrIndex}-${idx}`}
                                className={`tma_input_entry ${
                                  week.isHoliday ? "tma_holiday_input" : ""
                                  }`}
                                onFocus={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  e.target.value = inputVal;
                                }}
                                onChange={(e) => {
                                  if (isTotalCol || isViewMode) return;
                                  updateTimeEntries(
                                    hrIndex,
                                    week,
                                    e.target.value,
                                    e.target
                                  );
                                }}
                                onBlur={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  e.target.value = inputVal;
                                }}
                                onInputChange={(e) => {
                                  if (isTotalCol || isViewMode) return;
                                  updateTimeEntries(
                                    hrIndex,
                                    week,
                                    e.target.value,
                                    e.target
                                  );
                                }}
                                min={0}
                                max={24}
                              />
                            );
                          })}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
            <hr />
            <div className="tma_time_total_hours">
              <div className="tma_time_total_hours--first">
                <p className="tma_time_label">{translate("labels.totalHours")}</p>
              </div>
              <div className="tma_time_total_hours--second">
                <div className="tma_col_count">
                {formattedWeekLabels.map((week, tIndex) => {
                  return ( 
                      <div key={tIndex} className="count">
                      {tIndex === formattedWeekLabels.length - 1
                        ? totalInputtedHours
                        : hrMappingByDate[week.comparator]?.total}
                    </div> 
                  );
                })}
                </div>
              </div>
            </div>
          </div>
          {!isViewMode && (
            <Button
              className={"tma_add_new_row"}
              text={translate("labels.add")}
              variantStyle="primary"
              onClick={() => addNewTaskRow()}
            />
          )}
          <div className="tma-form_field_content">
            <div className="tma_form-control">
              {attachments.map((_, idx, arr) => {
                return (
                  <div className="mb_10 full_row" key={idx}>
                    <Label>{translate("labels.attachments")}</Label>
                    <div
                      className={`fileUpload uploaded-file ${
                        attachments[idx] ?.length ? "uploaded-file" : ""
                      }`}
                    >
                      <FilePicker
                        text={translate("labels.chooseFile")}
                        variantStyle="primary"
                        className="tma_file_upload_btn"
                        disabled={isReadOnlyMode}
                        type="button"
                        id="tma_file_upload_btn_otherAttachments"
                        acceptMultiple={false}
                        onFileSelection={(files) =>
                          handleFileChange(idx, files)
                        }
                        onMaxSizeExceeded={handleMaxLimitExceeded}
                      />
                      {
                        <FileInfo
                          files={
                            attachments[idx] ?.file
                              ? [attachments[idx].file]
                              : []
                          }
                          isReadMode={isReadOnlyMode}
                          onFileRemove={() => {
                            handleOtherAttachmentsRemove(idx);
                          }}
                        />
                      }
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="tma_form-control">
            <Button
              className={"tma_add_new_row"}
              type="button"
              text={translate("labels.newAttachment")}
              variantStyle="primary"
              onClick={handleAddAttachment}
            />
          </div>
          <div className="tma_comment_box">
            <TextField
              label={translate("labels.comments")}
              rows={6}
              defaultValue={commentBoxRef ?.current ?.value}
              multiline
              ref={commentBoxRef}
              disabled={isViewMode}
              onChange={(e) => {
                syncTimesheetDetails(projectId, {
                  projectId,
                  timesheetId,
                  comments: e.target.value,
                  tasks: taskRows,
                  attachments,
                });
              }}
            />
          </div>

          {!isViewMode && (
            <div className="tma_timesheet_note">
              <p>{translate("labels.noFutureEntry")}</p>
            </div>
          )}
        </section>
      </section>
    </StyledCardSection>
  );
};

export default TimesheetDetails;
